import { render, staticRenderFns } from "./mcp-documentation-reference.vue?vue&type=template&id=747566d8&scoped=true&"
import script from "./mcp-documentation-reference.vue?vue&type=script&lang=js&"
export * from "./mcp-documentation-reference.vue?vue&type=script&lang=js&"
import style0 from "./mcp-documentation-reference.vue?vue&type=style&index=0&id=747566d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747566d8",
  null
  
)

export default component.exports